import { blocksSchema, filesSchema } from "./blocks-schema";

export function getTransforms() {
  return blocksSchema.map((transform) => {
    return transform.isMatch
      ? transform
      : {
          ...transform,
          isMatch: (node) =>
            transform.selector && node.matches(transform.selector),
        };
  });
}

export function getFilesTransforms() {
  return filesSchema;
}
